<div class="container mt-0 mt-md-5">
  <div class="row">
    <div class="col-md-11 mx-auto">
      <div class="flex-row my-5" style="border-radius: 1rem">
        <div style="background-color: white; border-radius: 1rem; height: 100%">
          <h5
            *ngIf="surveyType === 'FeedbackPloom'"
            class="text-center my-4 text-dark fst-italic"
            style="
              font-family: system-ui, -apple-system, 'Segoe UI', Roboto,
                'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans',
                sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
                'Segoe UI Symbol', 'Noto Color Emoji';
              font-weight: 900;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 70px;
            "
          >
            Spune-ne părerea ta!
          </h5>

          <div class="row justify-content-center">
            <div class="col-12">
              <form class="px-4" action="" #myform="ngForm">
                <div
                  class="row"
                  *ngFor="let question of renderQuestions(); let i = index"
                  style="margin-top: 20px"
                >
                  <app-question
                    [id]="question.id"
                    class="box box-{{ question.id }}"
                    [question]="question"
                    [index]="i + 1"
                    ngModelGroup="{{ question.id }}_group"
                    style="
                      box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.2),
                        0 6px 8px 0 rgba(0, 0, 0, 0.19) !important;
                      padding: 0.5em 1em 1.5em;
                      box-sizing: border-box;
                    "
                  >
                  </app-question>
                </div>

                <div
                  class="row justify-content-center"
                  style="margin-top: 40px; margin-bottom: 20px"
                >
                  <button
                    type="button"
                    class="btn btn-success col-md-3 col-lg-3 col-xs-5 col-sm-5"
                    (click)="sendResults(myform.form)"
                    [disabled]="
                      !validateForm(myform.form) || hasAlreadyBeenClicked
                    "
                    [ngStyle]="{
                      display:
                        surveyType === 'FeedbackPloom' &&
                        (!validateForm(myform.form) || hasAlreadyBeenClicked)
                          ? 'none'
                          : ''
                    }"
                  >
                    Finalizare
                  </button>
                </div>
              </form>
            </div>
          </div>

          <footer *ngIf="surveyType === 'FeedbackPloom'" class="text-center">
            <p
              style="
                font-size: 14px;
                color: gray;
                font-style: italic;
                padding-bottom: 10px !important;
              "
            >
              18+ Produsul nu este lipsit de riscuri si poate crea dependenta
            </p>
            <!-- <div style="height: 10px;"></div> -->
          </footer>
          <app-footer
            *ngIf="
              surveyType === 'PLOOM3_1' ||
              surveyType === 'PLOOM3_3' ||
              surveyType === 'PLOOM3_6' ||
              surveyType === 'PLOOM3_12' ||
              surveyType === 'PLOOM4_1' ||
              surveyType === 'PLOOM4_3' ||
              surveyType === 'PLOOM4_6' ||
              surveyType === 'PLOOM4_12' ||
              surveyType === 'SurveyBurgundy'
            "
          ></app-footer>
        </div>
      </div>
    </div>
  </div>
</div>
